export function ExternalLinkIcon({
  className = 'text-white',
}: {
  className?: string;
}) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.96674 4.00008H4.30007C3.56369 4.00008 2.96674 4.59703 2.96674 5.33341V12.0001C2.96674 12.7365 3.56369 13.3334 4.30007 13.3334H10.9667C11.7031 13.3334 12.3001 12.7365 12.3001 12.0001V9.33341M9.6334 2.66675H13.6334M13.6334 2.66675V6.66675M13.6334 2.66675L6.96674 9.33341"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
